import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: resolve => require(['../components/HelloWorld.vue'], resolve),
      meta: {title: '森途学苑',navShow:true}
    },
    {
      path: '/list',
      name: 'list',
      component: resolve => require(['../components/list.vue'], resolve),
      meta: {title: '直播列表页',navShow:true},
    },
    {
      path: '/zhibovideo',
      name: 'zhibovideo',
      component: resolve => require(['../components/zhibovideo.vue'], resolve),
      meta: {title: '直播详情页'},
    },
    {
      path: '/course',
      name: 'course',
      component: resolve => require(['../components/course.vue'], resolve),
      meta: {title: '课程'},
    },
    {
      path: '/courselist',
      name: 'courselist',
      component: resolve => require(['../components/courselist.vue'], resolve),
      meta: {title: '课程'},
    },
    {
      path: '/report',
      name: 'report',
      component: resolve => require(['../components/report.vue'], resolve),
      meta: {title: '报告'},
    },
    {
      path: '/reports',
      name: 'reports',
      component: resolve => require(['../components/reports.vue'], resolve),
      meta: {title: '报告详情'},
    },
    {
      path: '/study',
      name: 'study',
      component: resolve => require(['../components/study.vue'], resolve),
      meta: {title: '学习路径',navShow:true},
    },
    {
      path: '/studyes',
      name: 'studyes',
      component: resolve => require(['../components/studyes.vue'], resolve),
      meta: {title: '学习路径就业'},
    },
    {
      path: '/assess',
      name: 'assess',
      component: resolve => require(['../components/assess.vue'], resolve),
      meta: {title: '测评'},
    },
    {
      path: '/gyname',
      name: 'gyname',
      component: resolve => require(['../components/gyname.vue'], resolve),
      meta: {title: '关于我们'},
    },
    {
      path: '/assesslist',
      name: 'assesslist',
      component: resolve => require(['../components/assesslist.vue'], resolve),
      meta: {title: '职业性格答题'},
    },
    {
      path: '/zyassesslist',
      name: 'zyassesslist',
      component: resolve => require(['../components/zyassesslist.vue'], resolve),
      meta: {title: '职业兴趣答题'},
    },
    {
      path: '/jzgassesslist',
      name: 'jzgassesslist',
      component: resolve => require(['../components/jzgassesslist.vue'], resolve),
      meta: {title: '职业价值观答题'},
    },
    {
      path: '/jzgassess',
      name: 'jzgassess',
      component: resolve => require(['../components/jzgassess.vue'], resolve),
      meta: {title: '职业兴趣结果图'},
    },
    {
      path: '/zgassess',
      name: 'zgassess',
      component: resolve => require(['../components/zgassess.vue'], resolve),
      meta: {title: '职业性格结果图'},
    },
    {
      path: '/qzassess',
      name: 'qzassess',
      component: resolve => require(['../components/qzassess.vue'], resolve),
      meta: {title: '职业气质结果图'},
    },
    {
      path: '/qzassesslist',
      name: 'qzassesslist',
      component: resolve => require(['../components/qzassesslist.vue'], resolve),
      meta: {title: '职业气质答题'},
    },
    {
      path: '/gtjj',
      name: 'gtjj',
      component: resolve => require(['../components/gtjj.vue'], resolve),
      meta: {title: '沟通交际能力测评'},
    },
    {
      path: '/qxkz',
      name: 'qxkz',
      component: resolve => require(['../components/qxkz.vue'], resolve),
      meta: {title: '情绪控制能力测评'},
    },
    {
      path: '/sjzx',
      name: 'sjzx',
      component: resolve => require(['../components/sjzx.vue'], resolve),
      meta: {title: '实践执行能力测评'},
    },
    {
      path: '/sy',
      name: 'sy',
      component: resolve => require(['../components/sy.vue'], resolve),
      meta: {title: '适应能力测评'},
    },
    {
      path: '/sw',
      name: 'sw',
      component: resolve => require(['../components/sw.vue'], resolve),
      meta: {title: '思维能力测评'},
    },
    {
      path: '/tdhz',
      name: 'stdhz',
      component: resolve => require(['../components/tdhz.vue'], resolve),
      meta: {title: '团队合作能力测评'},
    },
    {
      path: '/logo',
      name: 'logo',
      component: resolve => require(['../components/logo.vue'], resolve),
      meta: {title: '登录'},
    },
    {
      path: '/passwod',
      name: 'passwod',
      component: resolve => require(['../components/passwod.vue'], resolve),
      meta: {title: '修改密码'},
    },
    {
      path: '/nuser',
      name: 'nuser',
      component: resolve => require(['../components/nuser.vue'], resolve),
      meta: {title: '个人中心',navShow:true},
    },
    {
      path: '/History',
      name: 'History',
      component: resolve => require(['../components/History.vue'], resolve),
      meta: {title: '历史记录'},
    },
    {
      path: '/audios',
      name: 'audios',
      component: resolve => require(['../components/audios.vue'], resolve),
      meta: {title: '音频'},
    },
    {
      path: '/video',
      name: 'video',
      component: resolve => require(['../components/video.vue'], resolve),
      meta: {title: '视频'},
    },
    {
      path: '/videolj',
      name: 'videolj',
      component: resolve => require(['../components/videolj.vue'], resolve),
      meta: {title: '路径视频'},
    },
    {
      path: '/jianli',
      name: 'jianli',
      component: resolve => require(['../components/jianli.vue'], resolve),
      meta: {title: '简历'},
    },
    {
      path: '/jianlis',
      name: 'jianlis',
      component: resolve => require(['../components/jianlis.vue'], resolve),
      meta: {title: '简历详情'},
    },
    {
      path: '/shoucang',
      name: 'shoucang',
      component: resolve => require(['../components/shoucang.vue'], resolve),
      meta: {title: '收藏'},
    },
    {
      path: '/means',
      name: 'means',
      component: resolve => require(['../components/means.vue'], resolve),
      meta: {title: '个人资料'},
    },
    {
      path: '/zyassess',
      name: 'zyassess',
      component: resolve => require(['../components/zyassess.vue'], resolve),
      meta: {title: '职业测评'},
    },
    {
      path: '/nlassess',
      name: 'nlassess',
      component: resolve => require(['../components/nlassess.vue'], resolve),
      meta: {title: '职业测评'},
    },
    {
      path: '/audiolist',
      name: 'audiolist',
      component: resolve => require(['../components/audiolist.vue'], resolve),
      meta: {title: '音频列表'},
    },
    {
      path: '/audio',
      name: 'audio',
      component: resolve => require(['../components/audio.vue'], resolve),
      meta: {title: '音频'},
    },
	{
	  path: '/stbbm',
	  name: 'stbbm',
	  component: resolve => require(['../components/stbbm.vue'], resolve),
	  meta: {title: '森途杯报名'},
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js